import { render, staticRenderFns } from "./GoodsForm1.vue?vue&type=template&id=70314428&scoped=true&"
import script from "./GoodsForm1.vue?vue&type=script&lang=js&"
export * from "./GoodsForm1.vue?vue&type=script&lang=js&"
import style0 from "./GoodsForm1.vue?vue&type=style&index=0&id=70314428&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70314428",
  null
  
)

export default component.exports